import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
	ChangePlanQuotaDataProps,
	CreateBillingLinkDataResponse,
	GetPlanDataResponse,
	GetPlanProductDataResponse,
	PdfDataResponse,
	SubscribePlanDataProps,
} from './types/billing.interfaces'
import { DefaultGetParamsProps } from './types/interfaces'

const URL = '2/billing'

export const BillingService = {
	async getPlan(params: any): Promise<GetPlanDataResponse> {
		const response: AxiosResponse<GetPlanDataResponse> =
			await apiNode.get<GetPlanDataResponse>(`${URL}/plan`, {
				params,
			})

		return response.data
	},

	async updatePlanFeatures({ value }: { value: number }) {
		return apiNode.patch(`${URL}/plan/features`, { value })
	},

	async changePlanQuota(data: ChangePlanQuotaDataProps) {
		return apiNode.post<CreateBillingLinkDataResponse>(
			`${URL}/plan/changequota`,
			data,
		)
	},

	async createSubscribeLink(data: SubscribePlanDataProps) {
		return apiNode.post<CreateBillingLinkDataResponse>(
			`${URL}/plan/subscribe`,
			data,
		)
	},
	async createRetryLink({ id }: DefaultGetParamsProps) {
		return apiNode.post<CreateBillingLinkDataResponse>(
			`${URL}/invoices/${id}/receipt`,
			{},
		)
	},
	async renewPlan() {
		return apiNode.post(`${URL}/plan/renew`, {})
	},
	async cancelPlan() {
		return apiNode.post(`${URL}/plan/cancel`, {})
	},
	async createChangePaymentLink() {
		return apiNode.post<CreateBillingLinkDataResponse>(
			`${URL}/customer-portal`,
			{},
		)
	},
	async getReceipt({ id }: DefaultGetParamsProps): Promise<PdfDataResponse> {
		const response: AxiosResponse<ArrayBuffer> = await apiNode.get<ArrayBuffer>(
			`${URL}/invoices/${id}/receipt`,
			{
				responseType: 'arraybuffer',
			},
		)
		return {
			data: response.data,
			errors: [],
			success: true,
		}
	},

	async getInvoice({ id }: DefaultGetParamsProps): Promise<PdfDataResponse> {
		const response: AxiosResponse<ArrayBuffer> = await apiNode.get<ArrayBuffer>(
			`${URL}/invoices/${id}/invoice`,
			{
				responseType: 'arraybuffer',
			},
		)
		return {
			data: response.data,
			errors: [],
			success: true,
		}
	},

	async getPlanProduct(): Promise<GetPlanProductDataResponse> {
		const response: AxiosResponse<GetPlanProductDataResponse> =
			await apiNode.get<GetPlanProductDataResponse>(`${URL}/plan/product`)
		if (!response.data?.success || !Array.isArray(response.data.data)) {
			throw new Error('Unable to load plan products.')
		}
		return response.data
	},
}
